export default "__VITE_ASSET__BrNEOQQW__"